<template>
  <div>
    <div class="p-4 rounded-xl shadow-md bg-white space-y-2">
      <div class="flex items-center justify-between">
        <p class="text-sm font-medium text-gray-500">Classement réseau</p>
        <p class="text-sm font-medium text-gray-500">
          {{ $d(new Date(), "monthly") }}
        </p>
      </div>

      <div class="max-h-32 overflow-y-auto">
        <Table :columns="columns" :data="formattedStoreRanking" />
      </div>
    </div>
  </div>
</template>

<script>
import { Table } from "@estaly/ui";

export default {
  components: {
    Table,
  },
  props: {
    storeRanking: {
      type: Array,
      required: true,
    },
  },
  computed: {
    formattedStoreRanking() {
      return this.storeRanking.map((store) => ({
        rank: store.rank,
        salesChannel: store.salesChannel,
        sales: store.salesCount,
        rowClass: store.current ? "text-purple-700" : "",
      }));
    },

    columns() {
      return [
        {
          label: "#",
          field: "rank",
          numeric: true,
        },
        {
          label: "Magasin",
          field: "salesChannel",
        },
        {
          label: "Contrats",
          field: "sales",
          numeric: true,
        },
      ];
    },
  },
};
</script>
